import React from 'react'
import { OfferTeaser } from '.'
import { TeaserProps } from './teaser'

export const OfferListCommon = ({
  offers = [],
  emptyMessage,
  color,
}: {
  offers: TeaserProps[]
  emptyMessage: string
  color?: string
}) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {offers.length > 0 ? (
      offers.map((offer) => (
        <div key={offer?.slug}>
          {offer && <OfferTeaser {...offer} color={color} />}
        </div>
      ))
    ) : (
      <p className="text-center">{emptyMessage}</p>
    )}
  </>
)
